import { RouterProvider } from 'react-router-dom';
import { router } from '@navigation/router.jsx';
import '@styles/index.style.css';
import * as Sentry from '@sentry/react';

const SentryRouterProvider =
  Sentry.withSentryReactRouterV7Routing(RouterProvider);

function App() {
  return <SentryRouterProvider router={router} />;
}

export default App;
